import { render, staticRenderFns } from "./AboutApplicationSection.vue?vue&type=template&id=1554fb40&scoped=true&"
import script from "./AboutApplicationSection.vue?vue&type=script&lang=ts&"
export * from "./AboutApplicationSection.vue?vue&type=script&lang=ts&"
import style0 from "./AboutApplicationSection.vue?vue&type=style&index=0&id=1554fb40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1554fb40",
  null
  
)

export default component.exports